/* CAR ELECTRIC 2026 – Theme-Skript. Ohne Abhängigkeiten, nur Shopify-Standard-Endpunkte.
   11.10.2026: Kabelkonfigurator-Zeilen im Warenkorb gekoppelt (Kabel und Pauschale). */
(function () {
  'use strict';
  var T = window.ceTheme || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, text: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header */
  function schliesseMega(ausser) {
    $$('.ce-hd__top[aria-expanded="true"]').forEach(function (b) {
      if (b === ausser) return;
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button.ce-hd__top');
    if (b) {
      var offen = b.getAttribute('aria-expanded') === 'true';
      schliesseMega(b);
      b.setAttribute('aria-expanded', offen ? 'false' : 'true');
      var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = offen;
      return;
    }
    if (!e.target.closest('.ce-mega')) schliesseMega();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    schliesseMega(); schliesseAlle();
  });
  var hd = $('.ce-hd');
  if (hd && !hd.classList.contains('ce-hd--statisch')) {
    var kompakt = false;
    window.addEventListener('scroll', function () {
      var k = window.scrollY > 160;
      if (k !== kompakt) { kompakt = k; hd.classList.toggle('is-kompakt', k); if (k) schliesseMega(); }
    }, { passive: true });
  }

  /* Panels (Mobilmenü, Suche, Warenkorb) */
  var letzterFokus = null;
  function oeffne(id) {
    var el = document.getElementById(id); if (!el) return;
    letzterFokus = document.activeElement;
    el.hidden = false;
    if (el.dataset.sperren !== 'false') document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('[data-fokus]') || el.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function schliesse(el) {
    if (!el || el.hidden) return;
    el.hidden = true; document.documentElement.style.overflow = '';
    if (letzterFokus) letzterFokus.focus();
  }
  function schliesseAlle() { $$('[data-panel]').forEach(schliesse); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-oeffne]');
    if (o) {
      var ziel = document.getElementById(o.getAttribute('data-oeffne'));
      if (ziel) { e.preventDefault(); if (ziel.hidden) oeffne(ziel.id); else schliesse(ziel); }
      return;
    }
    var z = e.target.closest('[data-schliesse]');
    if (z) { e.preventDefault(); schliesse(z.closest('[data-panel]')); }
  });

  /* Ankündigung */
  $$('.ce-ank').forEach(function (a) {
    var msgs = $$('.ce-ank__msg', a); if (msgs.length < 2 || ruhig) return;
    var i = 0, pause = false;
    a.addEventListener('mouseenter', function () { pause = true; });
    a.addEventListener('mouseleave', function () { pause = false; });
    a.addEventListener('focusin', function () { pause = true; });
    setInterval(function () {
      if (pause) return;
      msgs[i].classList.remove('is-an'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-an');
    }, (parseInt(a.dataset.sekunden, 10) || 6) * 1000);
  });

  /* Wischleisten */
  function railUpd(w) {
    var r = $('.ce-rail', w), b = $$('.ce-paddle', w); if (!r || b.length < 2) return;
    b[0].disabled = r.scrollLeft < 8;
    b[1].disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
  }
  function initRails(scope) {
    $$('.ce-rail-wrap', scope).forEach(function (w) {
      if (w.dataset.ok) return; w.dataset.ok = '1';
      var r = $('.ce-rail', w); if (!r) return;
      r.addEventListener('scroll', function () { window.requestAnimationFrame(function () { railUpd(w); }); }, { passive: true });
      $$('.ce-paddle', w).forEach(function (p) {
        p.addEventListener('click', function () {
          var li = r.querySelector('li'); var breite = li ? li.getBoundingClientRect().width + 16 : 300;
          r.scrollBy({ left: breite * 2 * Number(p.dataset.richtung), behavior: ruhig ? 'auto' : 'smooth' });
        });
      });
      railUpd(w);
    });
  }
  initRails(document);
  window.addEventListener('resize', function () { $$('.ce-rail-wrap').forEach(railUpd); });

  /* Warenkorb */
  function sektionen() {
    var ids = [];
    if (document.getElementById('ce-wd')) ids.push('ce-warenkorb-schublade');
    var seite = $('[data-ce-warenkorb-seite]'); if (seite) ids.push(seite.dataset.ceWarenkorbSeite);
    return ids;
  }
  function tauscheSektionen(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var neu = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'ce-warenkorb-schublade') {
        var alt = $('#ce-wd-inhalt'), n = neu.querySelector('#ce-wd-inhalt');
        if (alt && n) alt.innerHTML = n.innerHTML;
      } else {
        var altS = document.getElementById('shopify-section-' + id), nS = neu.getElementById('shopify-section-' + id);
        if (altS && nS) altS.innerHTML = nS.innerHTML;
      }
    });
    var zaehl = $('#ce-wd-inhalt [data-anzahl]');
    if (zaehl) {
      var n2 = parseInt(zaehl.dataset.anzahl, 10) || 0;
      $$('[data-warenkorb-zaehler]').forEach(function (b) { b.textContent = n2; b.hidden = n2 === 0; });
    }
    kkWaisen();
  }
  window.ceWarenkorbTausch = tauscheSektionen;
  function aendere(line, menge, quelle) {
    var box = quelle && quelle.closest('.ce-zeile'); if (box) box.classList.add('ce-lade');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(menge)), sections: sektionen(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status && d.status >= 400) throw new Error(d.description || d.message);
      if (!d.sections || !Object.keys(d.sections).length) { window.location.reload(); return; }
      tauscheSektionen(d.sections);
    }).catch(function (err) {
      if (box) box.classList.remove('ce-lade');
      window.alert(err.message || T.text.fehler);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line][data-menge]');
    if (b) { e.preventDefault(); aendere(b.dataset.line, b.dataset.menge, b); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('input[data-line]');
    if (i) aendere(i.dataset.line, i.value, i);
  });
  /* 11.10.2026 Vorgabe Juli: Zeilen aus dem Kabelkonfigurator (data-kk = Kennung je Kabel)
     gehoeren zusammen. „Entfernen“ am Kabel loescht alle Zeilen dieser Kennung, die Pauschale
     (data-kk-rolle = konf) hat keinen eigenen Knopf. Sicherheitsnetz: eine Pauschale ohne Kabel
     wird beim Anzeigen des Warenkorbs entfernt. */
  function kkSchluessel(kk) {
    var s = {};
    $$('.ce-zeile[data-kk]').forEach(function (z) { if (z.dataset.kk === kk && z.dataset.key) s[z.dataset.key] = 1; });
    return Object.keys(s);
  }
  function kkEntfernen(keys, quelle, leise) {
    if (!keys.length) return;
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    var box = quelle && quelle.closest('.ce-zeile'); if (box) box.classList.add('ce-lade');
    fetch((T.routes.cart || '/cart') + '/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sektionen(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status && d.status >= 400) throw new Error(d.description || d.message);
      if (!d.sections || !Object.keys(d.sections).length) { window.location.reload(); return; }
      tauscheSektionen(d.sections);
    }).catch(function (err) {
      if (box) box.classList.remove('ce-lade');
      if (!leise) window.alert(err.message || T.text.fehler);
    });
  }
  var kkLaeuft = false;
  function kkWaisen() {
    if (kkLaeuft) return;
    var mitKabel = {}, teile = {};
    $$('.ce-zeile[data-kk]').forEach(function (z) {
      if (z.dataset.kkRolle === 'konf') { if (z.dataset.key) teile[z.dataset.key] = z.dataset.kk; }
      else { mitKabel[z.dataset.kk] = 1; }
    });
    var weg = Object.keys(teile).filter(function (k) { return !mitKabel[teile[k]]; });
    if (weg.length) { kkLaeuft = true; kkEntfernen(weg, null, true); setTimeout(function () { kkLaeuft = false; }, 3000); }
  }
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-kk-weg]');
    if (w) { e.preventDefault(); kkEntfernen(kkSchluessel(w.getAttribute('data-kk-weg')), w); }
  });
  kkWaisen();
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ce-ajax]');
    if (!f || T.cartType !== 'drawer' || !document.getElementById('ce-wd')) return;
    e.preventDefault();
    var knopf = f.querySelector('[type="submit"]'), fehler = f.querySelector('.ce-pf__fehler');
    if (knopf) { knopf.setAttribute('aria-busy', 'true'); knopf.disabled = true; }
    if (fehler) fehler.textContent = '';
    var fd = new FormData(f); fd.append('sections', sektionen().join(',')); fd.append('sections_url', window.location.pathname);
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) throw new Error(d.description || d.message);
        tauscheSektionen(d.sections); oeffne('ce-wd');
      })
      .catch(function (err) { if (fehler) fehler.textContent = err.message || T.text.fehler; })
      .finally(function () { if (knopf) { knopf.removeAttribute('aria-busy'); knopf.disabled = false; } });
  });

  /* Mengenfeld Produktseite */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var inp = b.parentNode.querySelector('input'); if (!inp) return;
    var v = (parseInt(inp.value, 10) || 1) + Number(b.dataset.qty); inp.value = Math.max(1, v);
  });

  /* Variantenwahl */
  $$('[data-ce-produkt]').forEach(function (root) {
    var daten = root.querySelector('script[data-varianten]'); if (!daten) return;
    var varianten = JSON.parse(daten.textContent);
    var geld = root.dataset.geldformat || '{{amount_with_comma_separator}} €';
    function fmt(cent) {
      var e = (cent / 100).toFixed(2).split('.'); var ganz = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return geld.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, ganz + ',' + e[1]).replace(/\{\{\s*amount\s*\}\}/, e[0] + '.' + e[1]).replace(/<[^>]*>/g, '');
    }
    function aktuell() {
      var opts = $$('fieldset[data-option]', root).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      return varianten.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    root.addEventListener('change', function (e) {
      if (!e.target.closest('fieldset[data-option]')) return;
      var v = aktuell(); var knopf = root.querySelector('[data-knopf]');
      var idFeld = root.querySelector('input[name="id"]');
      if (!v) { if (knopf) { knopf.disabled = true; knopf.textContent = T.text.nichtVerfuegbar; } return; }
      if (idFeld) idFeld.value = v.id;
      var p = root.querySelector('[data-preis]');
      if (p) p.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
      var sku = root.querySelector('[data-sku]'); if (sku) sku.textContent = v.sku || '';
      var lager = root.querySelector('[data-lager]');
      if (lager) { lager.classList.toggle('lager--aus', !v.available); var t = lager.querySelector('span'); if (t) t.textContent = v.available ? lager.dataset.an : lager.dataset.aus; }
      if (knopf) { knopf.disabled = !v.available; knopf.textContent = v.available ? T.text.inDenWarenkorb : T.text.ausverkauft; }
      if (v.featured_media) { var th = root.querySelector('.gal__thumbs button[data-media="' + v.featured_media.id + '"]'); if (th) th.click(); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
    });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.gal__thumbs button'); if (!t) return;
    var gal = t.closest('.product__media'); var main = gal && gal.querySelector('.gal__main img');
    $$('.gal__thumbs button', gal).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    if (main && t.dataset.src) { main.srcset = t.dataset.srcset || ''; main.src = t.dataset.src; main.alt = t.dataset.alt || ''; }
  });

  /* Filter */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-ce-filter]'); if (!f) return;
    if (e.target.type === 'number') return;
    var params = new URLSearchParams(new FormData(f));
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    window.location.search = params.toString();
  });

  /* Empfehlungen nachladen */
  $$('[data-empfehlungen]').forEach(function (s) {
    fetch(s.getAttribute('data-empfehlungen')).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var neu = d.querySelector('.ce-zgrid'); var alt = s.querySelector('.ce-zgrid');
      if (neu && neu.children.length) { alt.innerHTML = neu.innerHTML; } else { s.hidden = true; }
    }).catch(function () { s.hidden = true; });
  });

  /* Theme-Editor */
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();
